import L from 'leaflet'
import $ from 'jquery'
import 'leaflet-tooltip/dist/L.Tooltip'
import 'leaflet-tooltip/dist/tooltip.css'
import 'leaflet-kml'
import 'leaflet-velocity-ts'
import terminator from '@joergdietrich/leaflet.terminator'
// import 'leaflet-geotiff-2'
// import 'leaflet-geotiff-2/dist/leaflet-geotiff-plotty'
import moment from 'moment'

export default {
  name: 'BelugaMapOverlays',
  methods: {
    initLayers: function (widget) {
      // Google layers
      widget.layers.google_hybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
        maxZoom: 24,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        attribution: '&copy; Google'
      })
      widget.layers.google_terrain = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        maxZoom: 24,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        attribution: '&copy; Google'
      })
      // TODO: Dynamic from Config-File
      // Add OpenStreetMap Mapnik layer
      widget.layers.osm_mapnik = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 19,
        attribution: '&copy; OpenStreetmap',
        id: 'osm_mapnik',
        tileSize: widget.options.tileSize
      })
      widget.layers.osm_de = L.tileLayer('https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 18,
        attribution: '&copy; OpenStreetmap',
        id: 'osm_de',
        tileSize: widget.options.tileSize
      })
      widget.layers.opentopomap = L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
        maxZoom: widget.options.maxZoom,
        attribution: '&copy; OpenStreetMap, SRTM | &copy; OpenTopoMap (CC-BY-SA)',
        maxNativeZoom: 17,
        id: 'opentopomap',
        tileSize: widget.options.tileSize
      })
      widget.layers.opentopomap2 = L.tileLayer.wms('https://ows.terrestris.de/osm/service?', {
        maxZoom: widget.options.maxZoom,
        layers: 'TOPO-OSM-WMS',
        version: '1.1.1',
        format: 'image/png',
        // maxNativeZoom: 10,
        attribution: '&copy; OpenStreetMap, SRTM, terrestris GmbH & Co KG',
        id: 'opentopomap2',
        tileSize: widget.options.tileSize
      })
      // Add OpenStreetMap CartoCDN Light layer
      widget.layers.osm_cartodb_light = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png', {
        maxZoom: widget.options.maxZoom,
        attribution: '&copy; CartoCDN',
        id: 'osm_cartodb_light',
        tileSize: widget.options.tileSize
      })
      // Add OpenStreetMap CartoCDN Dark layer
      widget.layers.osm_cartodb_dark = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png', {
        maxZoom: widget.options.maxZoom,
        attribution: '&copy; CartoCDN',
        id: 'osm_cartodb_dark',
        tileSize: widget.options.tileSize
      })
      // Add OpenStreetMap CartoCDN Voyager layer
      widget.layers.osm_cartodb_voyager = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
        maxZoom: widget.options.maxZoom,
        attribution: '&copy; CartoCDN',
        subdomains: 'abcd',
        id: 'osm_cartodb_voyager'
      })
      widget.layers.osm_stamen_terrain = L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}{r}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 18,
        attribution: '&copy; Stamen Design',
        subdomains: 'abcd',
        id: 'osm_stamen_terrain'
      })
      // Add Esri World imagery
      widget.layers.esri_worldimagery = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 20,
        attribution: '&copy; Esri',
        id: 'esri_worldimagery',
        tileSize: widget.options.tileSize
      })
      // Add Argis Ocean BaseMap
      widget.layers.esri_oceanbasemap = L.tileLayer('https://server.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 13,
        attribution: '&copy; Esri',
        id: 'esri_oceanbasemap',
        tileSize: widget.options.tileSize
      })
      // Add EMODnet Bathymetry
      widget.layers.emodnet_bathymetry = L.tileLayer('https://tiles.emodnet-bathymetry.eu/2020/baselayer/web_mercator/{z}/{x}/{y}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 11,
        attribution: '&copy; EMODnet',
        id: 'emodnet_bathymetry',
        tileSize: widget.options.tileSize
      })
      // Add GEBCO Bathymetry
      widget.layers.gebco_bathymetry = L.tileLayer.wms('https://www.gebco.net/data_and_products/gebco_web_services/web_map_service/mapserv?', {
        maxZoom: widget.options.maxZoom,
        layers: 'GEBCO_LATEST',
        version: '1.3.0',
        format: 'image/png',
        // maxNativeZoom: 10,
        attribution: '&copy; Imagery reproduced from the GEBCO_2020 Grid, GEBCO Compilation Group (2020) GEBCO 2020 Grid',
        id: 'gebco_bathymetry',
        tileSize: widget.options.tileSize
      })
      // Add BSH Bathymetry
      widget.layers.bsh_bathymetry = L.tileLayer.wms('https://gdi.bsh.de/mapservice_gs/ELC_INSPIRE/ows?', {
        maxZoom: widget.options.maxZoom,
        layers: 'EL.GridCoverage,EL.GridCoverage_balticsea,EL.GridCoverage_northsea',
        styles: 'dgm_bathy,dgm_bathy,dgm_bathy',
        version: '1.3.0',
        format: 'image/png',
        // maxNativeZoom: 10,
        attribution: '&copy; BSH Germany',
        id: 'bsh_bathymetry',
        tileSize: widget.options.tileSize,
        transparent: true
      })
      // Add BSH Seabed sediments
      // widget.layers.bsh_sediments = L.tileLayer.wms('https://www.geoseaportal.de/wss/service/SGE_SeabedSediments_1_to_100000/guest?', {
      //   maxZoom: widget.options.maxZoom,
      //   layers: 'Stones,Seabed_Sediments',
      //   styles: 'SGE_SeabedSediments_1_to_100000:Stones,SGE_SeabedSediments_1_to_100000:Seabed_Sediments',
      //   version: '1.3.0',
      //   format: 'image/png',
      //   // maxNativeZoom: 10,
      //   attribution: '&copy; BSH Germany',
      //   id: 'bsh_sediments',
      //   tileSize: widget.options.tileSize,
      //   transparent: true
      // })
      // Add Argis Ocean BaseMap
      widget.layers.ncei_noaa = L.tileLayer('https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/multibeam_mosaic_hillshade/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 11,
        attribution: '&copy; NOAA National Centers for Environmental Information (NCEI)',
        id: 'ncei_noaa_multibeam',
        tileSize: widget.options.tileSize
      })
      // Add OpenSeaMap layer
      widget.layers.openseamap = L.tileLayer('https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 18,
        attribution: '&copy; OpenSeaMap.org',
        id: 'openseamap',
        tileSize: widget.options.tileSize,
        zIndex: 60
      })
      // Add MarineTraffic layer
      widget.layers.marinetraffic = L.tileLayer('https://tiles.marinetraffic.com/ais_helpers/shiptilesingle.aspx?output=png&sat=1&grouping=shiptype&tile_size=256&legends=1&zoom={z}&X={x}&Y={y}', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 18,
        attribution: '&copy; MarineTraffic.com',
        id: 'marinetraffic',
        tileSize: widget.options.tileSize,
        zIndex: 70
      })
      widget.layers.dwd_niederschlagsradar = L.tileLayer.wms('https://maps.dwd.de/geoserver/dwd/wms?', {
        maxZoom: widget.options.maxZoom,
        layers: 'Niederschlagsradar',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; Deutscher Wetterdienst',
        opacity: 0.75
      })
      widget.layers.dwd_warnungen_see = L.tileLayer.wms('https://maps.dwd.de/geoserver/dwd/wms?', {
        maxZoom: widget.options.maxZoom,
        layers: 'Warnungen_See',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; Deutscher Wetterdienst',
        zIndex: 10,
        opacity: 0.75
      })
      widget.layers.dwd_warnungen_kueste = L.tileLayer.wms('https://maps.dwd.de/geoserver/dwd/wms?', {
        maxZoom: widget.options.maxZoom,
        layers: 'Warnungen_Kueste',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; Deutscher Wetterdienst',
        zIndex: 20,
        opacity: 0.75
      })
      widget.layers.dwd_wolken = L.tileLayer.wms('https://maps.dwd.de/geoserver/dwd/wms?', {
        maxZoom: widget.options.maxZoom,
        layers: 'Satellite_worldmosaic_3km_world_ir108_3h',
        styles: 'satellite_worldmosaic_3km_world_ir108_3h_isoarea_tbw',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; Deutscher Wetterdienst',
        opacity: 0.5
      })
      widget.layers.dwd_seegang = L.tileLayer.wms('https://maps.dwd.de/geoserver/dwd/wms?', {
        maxZoom: widget.options.maxZoom,
        layers: 'dwd:Ewam_reg025_fd_sl_SWH',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; Deutscher Wetterdienst'
      })
      widget.layers.cmems_significantwaveheight = L.tileLayer.wms('https://nrt.cmems-du.eu/thredds/wms/global-analysis-forecast-wav-001-027', {
        maxZoom: widget.options.maxZoom,
        layers: 'VHM0',
        version: '1.3.0',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; CMEMS Copernicus.eu',
        styles: 'boxfill/rainbow'
      })
      widget.layers.cmems_seawatervelocity = L.tileLayer.wms('https://nrt.cmems-du.eu/thredds/wms/global-analysis-forecast-phy-001-024', {
        maxZoom: widget.options.maxZoom,
        layers: 'sea_water_velocity',
        version: '1.3.0',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; CMEMS Copernicus.eu',
        logscale: false,
        colorscalerange: '0.0000,2.5',
        belowmincolor: '0x0000ff',
        abovemincolor: '0xff0001',
        elevation: -0.49402499198913574,
        styles: 'boxfill/sst_36'
      })
      widget.layers.cmems_sealevelanomaly = L.tileLayer.wms('https://nrt.cmems-du.eu/thredds/wms/dataset-duacs-nrt-global-merged-allsat-phy-l4', {
        maxZoom: widget.options.maxZoom,
        layers: 'sla',
        version: '1.3.0',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; CMEMS Copernicus.eu',
        logscale: false,
        // colorscalerange: '-1.0,1.0',
        // belowmincolor: '0x0000ff',
        // abovemincolor: '0xff0001',
        // elevation: -0.49402499198913574,
        styles: 'boxfill/ferret'
      })
      widget.layers.pacioos_gfs_wind = L.tileLayer.wms('https://pae-paha.pacioos.hawaii.edu/thredds/wms/ncep_global/NCEP_Global_Atmospheric_Model_best.ncd', {
        maxZoom: widget.options.maxZoom,
        layers: 'wind',
        version: '1.3.0',
        transparent: true,
        format: 'image/png',
        attribution: '&copy; PacIOOS, GFS',
        styles: 'linevec/rdgy',
        // colorscalerange: '0,25.0',
        opacity: 0.6
      })
      widget.layers.arcgis_gebco_bathymetric_gridlines = L.tileLayer('https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/web_mercator_gebco_2019_contours/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: 11,
        maxNativeZoom: 10,
        zIndex: 10,
        opacity: 0.2,
        attribution: '&copy; ArcGIS, GEBCO'
      })

      // EEZ
      widget.layers.marineregions_eez = L.tileLayer.wms('https://geo.vliz.be/geoserver/MarineRegions/wms?', {
        maxZoom: widget.options.maxZoom,
        layers: 'eez_boundaries',
        version: '1.3.0',
        format: 'image/png',
        // maxNativeZoom: 10,
        attribution: '&copy; Marine Regions',
        id: 'marineregions_eez',
        tileSize: widget.options.tileSize,
        transparent: true,
        opacity: 0.5
      })

      // Marine heat waves
      widget.layers.marine_heat_waves = L.tileLayer.wms('https://maps.geomar.de/geoserver/OSIS_Underway/wms?', {
        maxZoom: widget.options.maxZoom,
        layers: 'OSIS_Underway:heatwave_category',
        version: '1.1.0',
        format: 'image/png',
        // maxNativeZoom: 10,
        attribution: '&copy; NOAA Coral Reef Watch',
        id: 'marine_heat_waves',
        tileSize: widget.options.tileSize,
        transparent: true,
        opacity: 0.5
      })

      const today = new Date(Date.now())
      // const yesterday = new Date(Date.now() - 864e5)
      const ereYesterday = new Date(Date.now() - 2 * 864e5)

      // TODO: Optimize and simplify
      const tdDateStr = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2)
      // const ydDateStr = yesterday.getFullYear() + '-' + ('0' + (yesterday.getMonth() + 1)).slice(-2) + '-' + ('0' + yesterday.getDate()).slice(-2)
      const ereYdDateStr = ereYesterday.getFullYear() + '-' + ('0' + (ereYesterday.getMonth() + 1)).slice(-2) + '-' + ('0' + ereYesterday.getDate()).slice(-2)

      widget.layers.gibs_modis_aqua_chlorophyl_a = L.tileLayer('https://gibs-c.earthdata.nasa.gov/wmts/epsg3857/best/MODIS_Terra_L2_Chlorophyll_A/default/' + tdDateStr + '/GoogleMapsCompatible_Level7/{z}/{y}/{x}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 7,
        zIndex: 40,
        attribution: '&copy; NASA Earthdata'
      })
      widget.layers.gibs_modis_terra_chlorophyl_a = L.tileLayer('https://gibs-c.earthdata.nasa.gov/wmts/epsg3857/best/MODIS_Terra_L2_Chlorophyll_A/default/' + tdDateStr + '/GoogleMapsCompatible_Level7/{z}/{y}/{x}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 7,
        zIndex: 50,
        attribution: '&copy; NASA Earthdata'
      })

      const dateStr = ereYdDateStr
      widget.layers.gibs_seasurfacetemperature = L.tileLayer('https://gibs-a.earthdata.nasa.gov/wmts/epsg3857/best/GHRSST_L4_MUR_Sea_Surface_Temperature/default/' + dateStr + '/GoogleMapsCompatible_Level7/{z}/{y}/{x}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 7,
        zIndex: 30,
        attribution: '&copy; NASA Earthdata'
      })
      widget.layers.gibs_seaiceconcentration = L.tileLayer('https://gibs-a.earthdata.nasa.gov/wmts/epsg3857/best/GHRSST_L4_MUR_Sea_Ice_Concentration/default/' + dateStr + '/GoogleMapsCompatible_Level7/{z}/{y}/{x}.png', {
        maxZoom: widget.options.maxZoom,
        maxNativeZoom: 7,
        zIndex: 31,
        attribution: '&copy; NASA Earthdata',
        opacity: 0.5
      })

      // widget.layers.fao_fishing_areas = L.tileLayer.wms('https://www.fao.org/fishery/geoserver/fifao/ows?', {
      //   // maxZoom: widget.options.maxZoom,
      //   layers: 'FAO_AREAS_CWP',
      //   version: '1.3.0',
      //   transparent: true,
      //   format: 'image/png',
      //   attribution: '&copy; FAO',
      //   opacity: 1.0
      // })

      // Add special overlays
      widget.layers.day_night = terminator()
      widget.layers.day_night.setStyle({
        fillOpacity: 0.3
      })
      setInterval(function () {
        widget.layers.day_night.setTime()
      }, 30000)

      // Geometric lines
      widget.layers.geographic_lines = L.geoJSON('', {
        onEachFeature: function (feature, layer) {
          layer.bindTooltip(feature.properties.name, {
            permanent: false,
            className: 'geometry-line-tooltip',
            opacity: 1.0,
            sticky: true,
            direction: 'top'
          })
        },
        style: function (feature) {
          return {
            color: '#387296', // 154360
            opacity: 0.6,
            dashArray: '2, 4',
            weight: 2
          }
        }
      })
      $.getJSON('https://beluga.geomar.de/data/overlays/generic/global/ne_10m_geographic_lines.json', function (data) {
        widget.layers.geographic_lines.addData(data)
      })

      // Campaign: Ocean change stations
      // TODO: Dynamic
      widget.layers.ocean_change_stations2024 = L.geoJSON('', {
        pointToLayer: function (feature, latlng) {
          return L.marker(latlng, {
            icon: L.icon({
              iconUrl: 'beluga-web/static/icons/poi.png',
              iconAnchor: [16, 25],
              tooltipAnchor: [0, 0],
              popupAnchor: [0, -30]
            }),
            tooltip: {
              html: feature.properties.port
            }
          })
        },
        onEachFeature: function (feature, layer) {
          if (feature.geometry.type === 'Point') {
            // let active = true
            // let canceledText = ''
            // if ('active' in feature.properties) {
            //   active = feature.properties.active === true
            // }
            // if (!active) {
            //   canceledText = '<br><span style="margin-left: 15px;" class="text-muted"><strong><i>Canceled</i></strong></span>'
            // }
            // layer.bindPopup('<h6 style="display: inline; color: #cf170f;">' +
            //   '<strong>' + feature.properties.station + '</strong></h6>&nbsp;' +
            //   '<span style="color: #cf170f;"><strong>' + feature.properties.habour + '</strong></span><br>' +
            //   '<span style="margin-left: 15px;">' + feature.properties.date_string + '</span>' + canceledText)
            layer.bindTooltip(feature.properties.port, {
              permanent: false,
              direction: 'bottom',
              className: 'station-tooltip',
              opacity: 1.0
            })
          }
        },
        style: function (feature) {
          if (feature.geometry.type === 'LineString') {
            return {
              color: feature.properties.stroke,
              opacity: feature.properties['stroke-opacity'],
              dashArray: '5, 10'
            }
          }
        }
      })
      $.getJSON('https://beluga.geomar.de/data/overlays/dagmaraaen/ocean-change-2024-stations.json', function (data) {
        widget.layers.ocean_change_stations2024.addData(data)
      })

      widget.layers.ocean_change_stations2025 = L.geoJSON('', {
        pointToLayer: function (feature, latlng) {
          return L.marker(latlng, {
            icon: L.icon({
              iconUrl: 'beluga-web/static/icons/poi.png',
              iconAnchor: [16, 25],
              tooltipAnchor: [0, 0],
              popupAnchor: [0, -30]
            }),
            tooltip: {
              html: feature.properties.port
            }
          })
        },
        onEachFeature: function (feature, layer) {
          if (feature.geometry.type === 'Point') {
            // let active = true
            // let canceledText = ''
            // if ('active' in feature.properties) {
            //   active = feature.properties.active === true
            // }
            // if (!active) {
            //   canceledText = '<br><span style="margin-left: 15px;" class="text-muted"><strong><i>Canceled</i></strong></span>'
            // }
            // layer.bindPopup('<h6 style="display: inline; color: #cf170f;">' +
            //   '<strong>' + feature.properties.station + '</strong></h6>&nbsp;' +
            //   '<span style="color: #cf170f;"><strong>' + feature.properties.habour + '</strong></span><br>' +
            //   '<span style="margin-left: 15px;">' + feature.properties.date_string + '</span>' + canceledText)
            layer.bindTooltip(feature.properties.port, {
              permanent: false,
              direction: 'bottom',
              className: 'station-tooltip',
              opacity: 1.0
            })
          }
        },
        style: function (feature) {
          if (feature.geometry.type === 'LineString') {
            return {
              color: feature.properties.stroke,
              opacity: feature.properties['stroke-opacity'],
              dashArray: '5, 10'
            }
          }
        }
      })
      $.getJSON('https://beluga.geomar.de/data/overlays/dagmaraaen/ocean-change-2025-stations.json', function (data) {
        widget.layers.ocean_change_stations2025.addData(data)
      })

      // Campaign: Ocean change science
      // TODO: Dynamic
      widget.layers.ocean_change_science = L.geoJSON('', {
        pointToLayer: function (feature, latlng) {
          return L.marker(latlng, {
            icon: L.icon({
              iconUrl: 'beluga-web/static/icons/poi_info.png',
              iconAnchor: [16, 25],
              tooltipAnchor: [0, 0],
              popupAnchor: [0, -30]
            })
          })
        },
        onEachFeature: function (feature, layer) {
          if (feature.geometry.type === 'Point') {
            layer.bindPopup(
              '<h6>' + feature.properties.title + '</h6>' +
              '<div class="mb-2">' + feature.properties.abstract + '</div>' +
              '<a href="' + feature.properties.url + '" target="_blank">' +
              '<strong>Read more on geomar.de &neArr;</strong>' +
              '</a>')
            layer.bindTooltip(feature.properties.label, {
              permanent: false,
              direction: 'bottom',
              className: 'info-tooltip',
              opacity: 1.0
            })
          }
        }
      })
      $.getJSON('https://beluga.geomar.de/data/overlays/dagmaraaen/ocean-change-2021-science.json', function (data) {
        widget.layers.ocean_change_science.addData(data)
      })

      // Campaign: Ocean change Eye on Water
      // TODO: Dynamic
      widget.layers.ocean_change_eyeonwater2024 = L.geoJSON('', {
        pointToLayer: function (feature, latlng) {
          const marker = L.circleMarker(latlng, {
            radius: 6,
            fill: true,
            fillColor: feature.properties.average_color,
            stroke: false,
            fillOpacity: 0.9
          })
          marker.on('click', function () {
            widget.map.panTo(latlng)
          })
          return marker
        },
        onEachFeature: function (feature, layer) {
          if (feature.geometry.type === 'Point') {
            layer.bindPopup('<a href="' + feature.properties.photo_url + '" target="_blank">' +
              '<img src="' + feature.properties.photo_url + '" style="width: 242px;" alt="Eye On Water Photo">' +
              '</a>' +
              '<div style="margin-top: 6px; font-size: 14px;">' +
              '<img src="beluga-web/static/logos/eyeonwater.png" style="opacity: 0.75; position: absolute; top: 18px; left: 24px; width: 80px;" alt="Eye On Water Logo">' +
              '<div>Photo taken on ' + moment.unix(feature.properties.timestamp).format('MMM D YYYY HH:mm:ss') + '</div>' +
              '<strong><a href="https://www.eyeonwater.org" target="_blank">More information on <span style="text-decoration: underline">eyeonwater.org</span></a></strong>' +
              '</div>', {
              offset: [0, 0]
            })
            layer.bindTooltip('Eye on Water', {
              permanent: false,
              direction: 'bottom',
              className: 'eyeonwater-tooltip',
              offset: [0, 6]
            })
          }
        }
      })
      $.getJSON('https://beluga.geomar.de/data/overlays/dagmaraaen/eyeonwater/ocean-change-2024-eyeonwater.json', function (data) {
        widget.layers.ocean_change_eyeonwater2024.addData(data)
      })

      widget.layers.ocean_change_eyeonwater2025 = L.geoJSON('', {
        pointToLayer: function (feature, latlng) {
          const marker = L.circleMarker(latlng, {
            radius: 6,
            fill: true,
            fillColor: feature.properties.average_color,
            stroke: false,
            fillOpacity: 0.9
          })
          marker.on('click', function () {
            widget.map.panTo(latlng)
          })
          return marker
        },
        onEachFeature: function (feature, layer) {
          if (feature.geometry.type === 'Point') {
            layer.bindPopup('<a href="' + feature.properties.photo_url + '" target="_blank">' +
              '<img src="' + feature.properties.photo_url + '" style="width: 242px;" alt="Eye On Water Photo">' +
              '</a>' +
              '<div style="margin-top: 6px; font-size: 14px;">' +
              '<img src="beluga-web/static/logos/eyeonwater.png" style="opacity: 0.75; position: absolute; top: 18px; left: 24px; width: 80px;" alt="Eye On Water Logo">' +
              '<div>Photo taken on ' + moment.unix(feature.properties.timestamp).format('MMM D YYYY HH:mm:ss') + '</div>' +
              '<strong><a href="https://www.eyeonwater.org" target="_blank">More information on <span style="text-decoration: underline">eyeonwater.org</span></a></strong>' +
              '</div>', {
              offset: [0, 0]
            })
            layer.bindTooltip('Eye on Water', {
              permanent: false,
              direction: 'bottom',
              className: 'eyeonwater-tooltip',
              offset: [0, 6]
            })
          }
        }
      })
      $.getJSON('https://beluga.geomar.de/data/overlays/dagmaraaen/eyeonwater/ocean-change-2025-eyeonwater.json', function (data) {
        widget.layers.ocean_change_eyeonwater2025.addData(data)
      })

      // Campaign: Ocean change stations
      // TODO: Dynamic
      widget.layers.ocean_change_ctdcasts2024 = L.geoJSON('', {
        pointToLayer: function (feature, latlng) {
          return L.marker(latlng, {
            icon: L.icon({
              iconUrl: 'beluga-web/static/icons/poi_cyan.png',
              iconAnchor: [16, 25],
              tooltipAnchor: [0, 0],
              popupAnchor: [0, -30]
            }),
            tooltip: {
              html: 'CTD Cast'
            }
          })
        },
        onEachFeature: function (feature, layer) {
          if (feature.geometry.type === 'Point') {
            layer.bindPopup('<img src="https://beluga.geomar.de/data/overlays/dagmaraaen/ctd/plots/' + feature.properties.figure + '" width="300" alt="CTD Cast">')
            layer.bindTooltip('CTD Cast', {
              permanent: false,
              direction: 'bottom',
              className: 'ctdcast-tooltip',
              opacity: 1.0
            })
          }
        },
        style: function (feature) {
          if (feature.geometry.type === 'LineString') {
            return {
              color: feature.properties.stroke,
              opacity: feature.properties['stroke-opacity'],
              dashArray: '5, 10'
            }
          }
        }
      })
      $.getJSON('https://beluga.geomar.de/data/overlays/dagmaraaen/ctd/ocean-change-2024-ctdcasts.json', function (data) {
        widget.layers.ocean_change_ctdcasts2024.addData(data)
      })

      this.addCastGeoJsonOverlay(widget,
        'https://beluga.geomar.de/data/overlays/dagmaraaen/ocean-change-2025-s4ocasts.json',
        'ocean_change_ctdcasts2025',
        'beluga-web/static/icons/poi_cyan.png',
        'CTD Cast',
        'ctdcast-tooltip',
        [16, 25],
        [0, 0],
        false)

      // const steinfischerBounds = [[54.633230183461627, 10.218485395846097], [54.634343544023302, 10.220339136749267]]
      // widget.layers.bathymetry_steinfischer = L.imageOverlay('/data/overlays/steinfischer.png', steinfischerBounds)
      //
      // const bokniseckBounds = [[54.534013712, 10.042394938], [54.536799873, 10.046699019]]
      // widget.layers.bathymetry_bokniseck = L.imageOverlay('/data/overlays/bathymetry_bokniseck.png', bokniseckBounds)

      // widget.layers.navionics_nautical_chart = new JNC.Leaflet.NavionicsOverlay({
      //   navKey: 'Navionics_webapi_03815',
      //   chartType: JNC.NAVIONICS_CHARTS.NAUTICAL,
      //   isTransparent: true,
      //   logoPayoff: false,
      //   zIndex: 1
      // })

      const sstAtlanticBounds = [[40.0, -32.0], [2.0, -12.0]]
      widget.layers.po_sst = L.imageOverlay('https://beluga.geomar.de/data/overlays/environment/local/sst/overlay_sst.php', sstAtlanticBounds, {
        opacity: 0.5
      })

      const slaAtlanticBounds = [[43.0, -28.0], [2.0, -8.0]]
      widget.layers.po_sla_eugen_atlantic = L.imageOverlay('https://beluga.geomar.de/data/overlays/environment/local/sla_es/overlay_sla_atlantic.php', slaAtlanticBounds, {
        opacity: 0.5
      })

      const slaPacificBounds = [[10, -95.0], [-5.0, -75.0]]
      widget.layers.po_sla_eugen_pacific = L.imageOverlay('https://beluga.geomar.de/data/overlays/environment/local/sla_es/overlay_sla_pacific.php', slaPacificBounds, {
        opacity: 0.5
      })

      // const senghorBounds = [[17.401886258, -21.574772950], [16.933880167, -22.309853181]]
      // widget.layers.senghor = L.imageOverlay('/data/overlays/senghor_seamount.png', senghorBounds, {
      //   opacity: 0.9
      // })

      // const stonefisherBounds = [[54.63394022435898, 10.219600386847196], [54.63372977564102, 10.219199613152805]]
      // widget.layers.stonefisher_color = L.imageOverlay('/data/overlays/F4_color.png', stonefisherBounds, {
      //   opacity: 0.9
      // })
      // widget.layers.stonefisher_contour = L.imageOverlay('/data/overlays/F4_contour.png', stonefisherBounds, {
      //   opacity: 0.9
      // })

      // FIXME: DEBUG Particles wind layers
      // const windyColormapWind = [
      //   'rgb(98, 113, 183)',
      //   'rgb(57, 97, 159)',
      //   'rgb(74, 148, 169)',
      //   'rgb(77, 141, 123)',
      //   'rgb(83, 165, 83)',
      //   'rgb(53, 159, 53)',
      //   'rgb(167, 157, 81)',
      //   'rgb(159, 127, 58)',
      //   'rgb(161, 108, 92)',
      //   'rgb(129, 58, 78)',
      //   'rgb(175, 80, 136)',
      //   'rgb(117, 74, 147)',
      //   'rgb(109, 97, 163)',
      //   'rgb(68, 105, 141)',
      //   'rgb(92, 144, 152)',
      //   'rgb(125, 68, 165)',
      //   'rgb(231, 215, 215)',
      //   'rgb(219, 212, 135)',
      //   'rgb(205, 202, 112)',
      //   'rgb(128, 128, 128)'
      // ]
      widget.layers.wind_1p00_particles = L.velocityLayer({
        displayValues: false, // FIXME
        displayOptions: {
          velocityType: 'Wind 1.0&deg;',
          position: 'topcenter',
          emptyString: 'No wind data'
        },
        data: [],
        colorScale: widget.getColormap('jet'),
        // velocityScale: 0.0075,
        // lineWidth: 1,
        particleAge: 50,
        particleMultiplier: 1 / 600,
        maxVelocity: 30,
        opacity: 0.9,
        attribution: '&copy; NOAA',
        id: 'wind_1p00_particles',
        angleConvention: 'meteoCW'
      })
      $.getJSON('/data/overlays/environment/global/wind/noaa_wind_grb2_1p00.json', function (data) {
        widget.layers.wind_1p00_particles.setData(data)
      })

      // widget.layers.wind_0p25_particles = L.velocityLayer({
      //   displayValues: false, // FIXME
      //   displayOptions: {
      //     velocityType: 'Wind 0.25&deg;',
      //     position: 'topcenter',
      //     emptyString: 'No wind data'
      //   },
      //   data: [],
      //   colorScale: widget.getColormap('jet'),
      //   // velocityScale: 0.0075,
      //   // lineWidth: 1,
      //   particleAge: 50,
      //   particleMultiplier: 1 / 600,
      //   maxVelocity: 30,
      //   opacity: 0.9,
      //   attribution: '&copy; NOAA',
      //   id: 'wind_0p25_particles',
      //   angleConvention: 'meteoCW'
      // })
      // $.getJSON('/data/overlays/wind/noaa_wind_grb2_0p25.json', function (data) {
      //   widget.layers.wind_0p25_particles.setData(data)
      // })

      // DEBUG: Currents particles layer
      // widget.layers.currents_particles = L.velocityLayer({
      //   displayValues: false, // FIXME
      //   displayOptions: {
      //     velocityType: 'Surface current',
      //     position: 'topcenter',
      //     emptyString: 'No surface current data'
      //   },
      //   data: [],
      //   colorScale: widget.getColormap('jet'),
      //   // lineWidth: 2,
      //   particleAge: 300,
      //   particleMultiplier: 1 / 250,
      //   velocityScale: 0.3,
      //   maxVelocity: 2,
      //   // opacity: 0.5,
      //   attribution: '&copy; ESR',
      //   id: 'currents_particles',
      //   angleConvention: 'bearingCW'
      // })
      // $.getJSON('/data/overlays/environment/global/currents/oscar_currents_nc_0p30.json', function (data) {
      //   widget.layers.currents_particles.setData(data)
      // })

      // widget.layers.geotiff_grimsey2 = L.leafletGeotiff(
      //   '/data/overlays/geotiff/2023-06-08_F1_grid_auto.tif',
      //   {
      //     renderer: L.LeafletGeotiff.plotty({
      //       // applyDisplayRange: false,
      //       colorScale: 'rdbu', // https://github.com/santilland/plotty
      //       displayMin: -420,
      //       displayMax: -359
      //     }),
      //     noDataValue: 9999,
      //     opacity: 0.6
      //   }
      // )
      //
      // widget.layers.geotiff_grimsey1 = L.leafletGeotiff(
      //   '/data/overlays/geotiff/2023-06-07_Anton283_F4_shallowest_auto.tif',
      //   {
      //     renderer: L.LeafletGeotiff.plotty({
      //       // applyDisplayRange: false,
      //       colorScale: 'rdbu', // https://github.com/santilland/plotty
      //       displayMin: -420,
      //       displayMax: -359
      //     }),
      //     noDataValue: 9999,
      //     opacity: 0.6
      //   }
      // )
      //
      // widget.layers.geotiff_grimsey3 = L.leafletGeotiff(
      //   '/data/overlays/geotiff/2023-06-09_F1_grid_auto.tif',
      //   {
      //     renderer: L.LeafletGeotiff.plotty({
      //       // applyDisplayRange: false,
      //       colorScale: 'rdbu', // https://github.com/santilland/plotty
      //       displayMin: -420,
      //       displayMax: -359
      //     }),
      //     noDataValue: 9999,
      //     opacity: 0.6
      //   }
      // )

      // FIXME: place information in datamodel (track info) to not need geojson files
      // add geojson overlay for s4o sondes
      this.addCastGeoJsonOverlay(widget,
        'https://beluga.geomar.de/data/overlays/s4o/s4o_casts.json',
        's4o2',
        'beluga-web/static/icons/poi_sonde-blue.png',
        'CTD Cast',
        's4o-tooltip',
        [16, 25],
        [0, 0],
        false)
      // add geojson overlay for ocean change 2024 sondes
      // this.addCastGeoJsonOverlay(widget,
      //   'https://beluga.geomar.de/data/overlays/dagmaraaen/ctd/dagmaraaen_casts.json',
      //   'ocean_change_ctd_interactive',
      //   'beluga-web/static/icons/poi_cyan.png',
      //   'CTD Cast',
      //   'ctdcast-tooltip',
      //   [16, 25],
      //   [0, 0],
      //   false)
    },
    addCastGeoJsonOverlay: function (widget, geojsonPath, layerName, iconUrl, tooltipHtml, tooltipClass,
      iconAnchor = [0, 0], tootltipAnchor = [0, 0], fading = false) {
      widget.layers[layerName] = L.geoJSON(null, {
        pointToLayer: function (feature, latlng) {
          const opFeature = (feature, fading) => {
            const ts = feature.properties.ts_start
            const stepSizeTime = 7884000 // in seconds (3 month)
            const stepSizeOp = 0.2
            const minOp = 0.5
            const maxOp = 1.0
            let stepperTs = new Date().getTime() / 1000 // get ts seconds (unix)
            let op = maxOp
            while ((stepperTs - stepSizeTime > ts) && (op - stepSizeOp >= minOp)) {
              stepperTs -= stepSizeTime
              op -= stepSizeOp
            }
            return op
          }
          return L.marker(latlng, {
            icon: L.icon({
              iconUrl: iconUrl,
              iconAnchor: iconAnchor,
              tooltipAnchor: tootltipAnchor,
              popupAnchor: [0, -30]
            }),
            zIndexOffset: 2000,
            tooltip: {
              html: tooltipHtml
            },
            opacity: (fading) ? opFeature(feature, fading) : 1.0
          })
        },
        onEachFeature: function (feature, layer) {
          layer.on('click', function () {
            // FIXME: Asynchronous datasets have to be delivered by common data model
            // FIXME: Unify identifier field names, platform ids must correspond to BELUGA platforms id!
            // FIXME: Dynamic approach
            const payload = {}
            payload.platform_id = feature.properties.beluga_id
            payload.dataset_id = feature.properties.ts_start
            if (feature.geometry.type === 'Point') {
              payload.latitude = feature.geometry.coordinates[1]
              payload.longitude = feature.geometry.coordinates[0]
            }
            payload.sta_id = feature.properties.platform
            payload.ts_start = feature.properties.ts_start
            payload.ts_end = feature.properties.ts_end
            payload.type = feature.properties.type
            payload.url_sta = feature.properties.url_sta
            if ('boat' in feature.properties) {
              payload.carrier = feature.properties.boat
            }
            if ('sensors' in feature.properties) {
              payload.sensors = feature.properties.sensors
            }
            widget.$store.commit('select_async_dataset', payload)
          })
          if (feature.geometry.type === 'Point') {
            layer.bindTooltip(tooltipHtml, {
              permanent: false,
              direction: 'bottom',
              className: tooltipClass,
              opacity: 1.0
            })
          }
        },
        style: function (feature) {
          if (feature.geometry.type === 'LineString') {
            return {
              color: feature.properties.stroke,
              opacity: feature.properties['stroke-opacity'],
              dashArray: '5, 10'
            }
          }
        }
      })
      $.getJSON(geojsonPath, function (data) {
        widget.layers[layerName].addData(data)
      })
    }
  }
}
